import React from 'react'
import { ListGroup } from 'react-bootstrap'
import ATListItem from './ATListItem'

interface ATListProps {
  data: any
  titleKey: string
  valueKey: string
  selectedItem: string | undefined | null
  handleSelectedItem: (val: any) => void
}

const ATList: React.FC<ATListProps> = ({
  data,
  titleKey = 'title',
  valueKey = 'title',
  selectedItem,
  handleSelectedItem,
}) => {
  const isActive = (val: string) => {
    return selectedItem === val
  }

  return (
    <ListGroup className="h-100 overflow-auto">
      {data?.map((item: any) => (
        <ATListItem
          key={item?.[valueKey]}
          listItem={item}
          titleKey={titleKey}
          valueKey={valueKey}
          isActive={isActive(item?.[valueKey])}
          handleSelectedItem={handleSelectedItem}
        />
      ))}
    </ListGroup>
  )
}

export default ATList
